/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import PropTypes from 'prop-types';
import TabMenu from 'features/userData/tab/TabMenu';
import { layoutStyles } from './style';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

const WorkspaceLayout = ({
    tabs = [],
    activeTab = 'layer',
    onTabChange = () => {},
    sidebarContent = null,
    children = null,
    initialCollapsed = false,
    showCalculatorButton = false,
    onCalculatorOpen = undefined,
}) => {
    const [collapsed, setCollapsed] = useState(initialCollapsed);
    const toggleCollapsed = () => setCollapsed((prev) => !prev);

    return (
        <div css={layoutStyles.mainContainer}>
            <div css={layoutStyles.sidebarWrapper}>
                <div css={[layoutStyles.sidebar, collapsed && layoutStyles.sidebarCollapsed]}>
                    <TabMenu
                        tabs={tabs}
                        activeTab={activeTab}
                        setActiveTab={onTabChange}
                        collapsed={collapsed}
                        showCalculatorButton={showCalculatorButton}
                        onCalculatorOpen={onCalculatorOpen}
                    />
                    {!collapsed && (
                        <div css={layoutStyles.sidebarContentWrapper}>
                            <button
                                type="button"
                                css={layoutStyles.inlineCollapseButton}
                                onClick={toggleCollapsed}
                                aria-label="메뉴 접기"
                            >
                                <ChevronLeftRoundedIcon fontSize="small" />
                            </button>
                            <div css={layoutStyles.sidebarContent}>{sidebarContent}</div>
                        </div>
                    )}
                </div>
                {collapsed && (
                    <button
                        type="button"
                        css={layoutStyles.collapseToggleButtonCollapsed}
                        onClick={toggleCollapsed}
                        aria-label="메뉴 펼치기"
                    >
                        <ChevronRightRoundedIcon fontSize="small" />
                    </button>
                )}
            </div>
            <div css={layoutStyles.contentArea}>{children}</div>
        </div>
    );
};

WorkspaceLayout.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.elementType,
        })
    ),
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func,
    sidebarContent: PropTypes.node,
    children: PropTypes.node,
    initialCollapsed: PropTypes.bool,
    showCalculatorButton: PropTypes.bool,
    onCalculatorOpen: PropTypes.func,
};

export default WorkspaceLayout;
